/**
 * Masks a string to allow only valid float values:
 * - Digits and a single dot only
 * - No leading dot
 */
export function maskFloatInput(value: string): string {
  if (!value) return '';
  let masked = value.replace(/[^0-9.]/g, ''); // remove invalid chars
  const parts = masked.split('.'); // allow only one dot
  if (parts.length > 2) masked = parts[0] + '.' + parts[1];
  if (masked.startsWith('.')) masked = ''; // prevent leading dot
  return masked;
}
